export const NotesFormName = 'notes-form';

export enum NotesFormFields {
  Notes = 'notes',
}

export interface INotesForm {
  notes: string;
}
